import { useSearchParams } from "react-router-dom";
import { InputHelper } from "../../utils/InputHelper";
import { Fragment, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Button, Card, Empty, Flex, Input, Row, Skeleton } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import {
    mdlReservationValidateDisplayRequest
} from "../../models/service-models/reservation/ReservationDisplayValidateRequest";
import { useQuery } from "react-query";
import { ReservationService } from "../../services/ReservationService";
import { SFModal } from "../../components/elements/SFModal";
import { useTranslation } from "react-i18next";
import { ReservationDetail } from "../../components/reservation/ReservationDetail";
import { ReservationConfirm } from "../../components/reservation/ReservationConfirm";
import { ReservationReject } from "../../components/reservation/ReservationReject";
import { mdlReservation } from "../../models/domain/Reservation";
import { enmPdfExportType } from "../../models/enums/PdfExportType";
import { mdlPDFRendererProps } from "../../models/ui-models/PDFRendererProps";
import { enmPdfRendererType } from "../../models/enums/PdfRenderer";
import { setPdfExportObject } from "../../store/SiteSlice";
import { useAppDispatch } from "../../store/Hooks";
import { enmConfirmationStatus } from "../../models/enums/ConfirmationStatus";

export const ResDisplay = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const oldId = searchParams.get('Id');
    const hotel = searchParams.get('hotel');
    const oldHotel = searchParams.get('HotelID');
    const oldPass = searchParams.get('Number');
    const dataReady = false;
    const [valid, setValid] = useState<boolean>(false);
    const [request, setRequest] = useState<mdlReservationValidateDisplayRequest>({});
    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const captchaTokenRef = useRef<string | null>(null);
    const [openPasscodeModal, setOpenPassCodeModal] = useState<boolean>(false);
    const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
    const [openRejectModal, setOpenRejectModal] = useState<boolean>(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (
            (InputHelper.isNullOrUndefinedOrEmpty(oldHotel) && (InputHelper.isNullOrUndefinedOrEmpty(id) || InputHelper.isNullOrUndefinedOrEmpty(hotel)))
            &&
            (InputHelper.isNullOrUndefinedOrEmpty(hotel) && (InputHelper.isNullOrUndefinedOrEmpty(oldId) || InputHelper.isNullOrUndefinedOrEmpty(oldHotel)))) {
            toast.error("Invalid Url");
        }
        else {
            if (!request.passCode) {
                console.log(oldPass);
                if (oldPass != null) {
                    console.log('asdasd');
                    setRequest({ ...request, ["resId"]: oldId!, ["passCode"]: Number(oldPass), ["paxId"]: Number(oldHotel)! });
                    setTimeout(function () { refetch(); }, 500);
                } else {
                    setRequest({ ...request, ["resId"]: id!, ["paxId"]: Number(hotel)! })
                    setOpenPassCodeModal(true);
                }
            }
        }
    }, [id, hotel, oldHotel, oldId])


    const {
        data,
        isLoading,
        refetch,
    } = useQuery(
        ["getReservations", request.passCode, request.paxId, request.resId],
        () => {
            if (request)
                return ReservationService.ResDisplayValidate({ ...request, captchaToken: captchaTokenRef.current ?? undefined });

        },
        {
            refetchOnWindowFocus: false,
            enabled: false,
            cacheTime: 0,
            staleTime: 0
        }
    );

    const handlePassCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.currentTarget.value) {
            setRequest({ ...request, ["passCode"]: Number(e.currentTarget.value) })
        }
    }

    const exportToPDF = (type: enmPdfExportType, reservations: Array<mdlReservation>) => {
        var exportProps: mdlPDFRendererProps = {
            params: { reservations: reservations },
            rendererType: enmPdfRendererType.ReservationVoucher,
            type: type
        }
        dispatch(setPdfExportObject(exportProps));
    }

    const handleOuterPrintPreview = (reservation?: mdlReservation) => {
        if (reservation)
            exportToPDF(enmPdfExportType.PRINT, [reservation]);
    }

    const handleOuterExportToPDF = (reservation?: mdlReservation) => {
        if (reservation)
            exportToPDF(enmPdfExportType.PDF, [reservation]);
    }

    const onSubmitPassCode = async () => {
        if (!request.passCode) {
            toast.error(t("monitor.checkPasscode"));
            return;
        }
        if (request.passCode != null && request.passCode.toString().length === 0) {
            toast.error(t("monitor.checkPasscode"));
            return;
        }

        const captchaToken = recaptchaRef.current?.getValue();
        if (!captchaToken) {
            toast.error(t("monitor.checkCaptcha"));
            return;
        }

        captchaTokenRef.current = captchaToken;
        setOpenPassCodeModal(false);

        const result = await refetch();

        if (!result?.data?.header.success) {
            const msg = result?.data?.header?.messages?.[0]?.message;
            if (msg == "INVALID_PASSCODE") {
                toast.error(t("monitor.invalidPassCode"));
                recaptchaRef.current?.reset();
                captchaTokenRef.current = null;
                setOpenPassCodeModal(true);
            }
            else if (msg == "RESERVATION_DOES_NOT_EXIST") {
                toast.error(t("monitor.reservationDoesNotExist"));
            }
            else if (msg == "RESERVATION_NOT_FOUND") {
                toast.error(t("monitor.reservationNotFound"));
            }
            else if (msg == "INVALID_CAPTCHA") {
                toast.error(t("monitor.invalidCaptcha"));
            }
        }
    }

    const handleConfirmCallback = () => {
        toast.success(t("monitor.confirmedSuccessfully"));
        setOpenConfirmModal(false);
        setOpenRejectModal(false);
        data!.body!.data!.confirmationStatus = enmConfirmationStatus.Yes;
    }

    const handleRejectCallback = () => {
        toast.success(t("monitor.notConfirmedSuccessfully"));
        setOpenConfirmModal(false);
        setOpenRejectModal(false);
        data!.body!.data!.confirmationStatus = enmConfirmationStatus.No;

    }

    const handleConfirmClick = (reservation: mdlReservation) => {
        setOpenRejectModal(false);
        setOpenConfirmModal(true);
    }

    const handleRejectClick = () => {
        setOpenConfirmModal(false);
        setOpenRejectModal(true);
    }

    var isSucceed = data?.header.success;

    return (
        <Fragment>
            {
                <Card loading={isLoading}>
                    {
                        !isSucceed
                            ?
                            <Card style={{ height: "100vh" }}>
                                <Empty />
                            </Card>
                            :
                            <>
                                <ReservationDetail onExport={handleOuterExportToPDF} onPrint={handleOuterPrintPreview} onConfirmClick={handleConfirmClick} onRejectClick={handleRejectClick} displayMode={true} reservation={data?.body?.data} />
                                {
                                    data?.body?.data
                                    &&
                                    <>
                                        <SFModal
                                            width={window.innerWidth * 99 / 100}
                                            open={openConfirmModal}
                                            toggler={() => { setOpenConfirmModal(!openConfirmModal) }}
                                            body={<ReservationConfirm callback={handleConfirmCallback} fromEmail={true} open={openConfirmModal} reservations={[data?.body?.data]} closeCallBack={() => setOpenConfirmModal(false)} />}
                                            title={t("resConfirm.title")}
                                        />
                                        <SFModal
                                            width={window.innerWidth * 99 / 100}
                                            open={openRejectModal}
                                            toggler={() => { setOpenRejectModal(!openRejectModal) }}
                                            body={<ReservationReject displayMode={true} callback={handleRejectCallback} fromEmail={true} open={openConfirmModal} reservations={[data?.body?.data]} closeCallBack={() => setOpenConfirmModal(false)} />}
                                            title={t("resReject.title")}
                                        />
                                    </>
                                }

                            </>
                    }
                </Card>
            }
            {
                isLoading
                &&
                <>
                    <Skeleton active={isLoading} />
                    <Skeleton active={isLoading} />
                    <Skeleton active={isLoading} />
                    <Skeleton active={isLoading} />
                    <Skeleton active={isLoading} />
                </>
            }
            <SFModal
                width={window.innerWidth * 35 / 100}
                open={openPasscodeModal}
                toggler={() => { setOpenPassCodeModal(!openPasscodeModal) }}
                body={
                    <Card loading={isLoading}>
                        <Flex vertical gap={15}>
                            <Row>
                                <strong>{t("monitor.passCode")}</strong>
                            </Row>
                            <Row>
                                <label style={{ fontStyle: "italic" }}>{t("monitor.passCodeDesc")}</label>
                            </Row>
                            <Row>
                                <Input status="warning" onChange={handlePassCodeChange} />
                            </Row>
                            <Row>
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY!}
                                />
                            </Row>
                            <Row>
                                <Button type="primary" onClick={onSubmitPassCode}>{t("common.confirm")}</Button>
                            </Row>
                        </Flex>

                    </Card>
                }
                title={t("monitor.passcodeRequired")}
            />
        </Fragment>

    )
}